export default __webpack_public_path__ + "resources/icons/n140-6553.png";